<template>
  <div class="staff">
    <Header/>
    <h1>Het team</h1>
    <div class="row">
        <div v-for="staff_m in staff" class="col-md-4 staff_member">
          <img v-bind:src="getFeaturedImage(staff_m)" />
          <h5>{{ staff_m.title.rendered }}</h5>
          <p>Lorem ipsum..</p>
        </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";

export default {
  name: 'Staff',
  components: { Header },
  data () {
    return {
      msg: 'Our staff',
      staff: []
    }
  },
  created: function(){
    this.$http.get('wp/v2/staff?_embed').then(response => {
      for(let staff_member in response.data){
        this.staff.push(response.data[staff_member]);
      }
    }, error => {
      alert(error);
    })
  }, 
  methods: {
    getFeaturedImage: function(staff_m){
      if(staff_m._embedded['wp:featuredmedia']){
        console.log(staff_m._embedded['wp:featuredmedia'][0].media_details.file)
        return 'http://schisisonderzoek.loc/wp-content/uploads/' + staff_m._embedded['wp:featuredmedia'][0].media_details.file
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/more_info/staff.vue